// Simple store/config for encryption
// By default we enable it if the REACT_APP_ENCRYPTION_ENABLED environment variable is not explicitly "false"

export const encryptionStore = {
  // Check if encryption is enabled. It is enabled by default unless explicitly disabled.
  isEnabled: process.env.REACT_APP_ENCRYPTION_ENABLED !== 'false'
};
